<div
    data-testid="selfBookingDepartureDetail"
    class="w-full rounded-2xl bg-white p-6 py-6 shadow-md md:px-7 md:py-3 md:pr-3">
    <div class="flex items-center justify-between md:mb-1">
        <p class="text-sm font-semibold text-deemphasized">
            {{ departure.title }}
        </p>

        <div
            (click)="toggleOpen()"
            class="flex cursor-pointer items-center p-4 md:hidden">
            <svg
                class="inline h-3 flex-shrink-0 transform fill-current text-grey-500 transition duration-500"
                [ngClass]="{ '-scale-y-100': open }"
                viewBox="0 0 20 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.666666 2.33333C0.666056 2.02179 0.774557 1.71988 0.973331 1.48C1.08526 1.34498 1.22273 1.23338 1.37786 1.15158C1.53299 1.06978 1.70273 1.01938 1.87737 1.00328C2.052 0.987179 2.2281 1.00569 2.39557 1.05775C2.56304 1.10981 2.7186 1.19439 2.85333 1.30666L10 7.28L17.16 1.52C17.2964 1.40924 17.4533 1.32653 17.6218 1.27662C17.7902 1.22672 17.9669 1.21059 18.1416 1.22918C18.3163 1.24776 18.4856 1.30069 18.6398 1.38492C18.794 1.46915 18.93 1.58303 19.04 1.72C19.1614 1.85795 19.2529 2.01951 19.3089 2.19452C19.3649 2.36954 19.3841 2.55424 19.3653 2.73703C19.3466 2.91982 19.2902 3.09676 19.1998 3.25673C19.1094 3.41671 18.9869 3.55627 18.84 3.66666L10.84 10.1067C10.6014 10.3028 10.3022 10.41 9.99333 10.41C9.6845 10.41 9.38524 10.3028 9.14666 10.1067L1.14667 3.44C0.985309 3.30624 0.857757 3.13633 0.774359 2.94405C0.69096 2.75177 0.654064 2.54254 0.666666 2.33333Z" />
            </svg>
        </div>
    </div>
    <div class="flex flex-col justify-between md:flex-row md:items-center">
        <div
            class="flex w-full flex-col justify-between gap-4 md:w-4/6 md:flex-row">
            <div class="flex flex-wrap items-center gap-4">
                <div class="flex items-center">
                    <img class="mr-2" src="/assets/images/trips/calendar.svg" />
                    <p class="text-xl font-semibold">
                        {{ departure.date | date: 'mediumDate' }}
                    </p>
                </div>
                <div class="flex items-center gap-1">
                    @switch (departure.display_status) {
                        @case (DisplayStatusEnum.Open) {
                            <p class="text-sm font-semibold text-green">
                                Open for bookings
                            </p>
                        }
                        @case (DisplayStatusEnum.FewSpots) {
                            <p class="text-sm font-semibold text-orange">
                                Few spaces left
                            </p>
                        }
                        @case (DisplayStatusEnum.SoldOut) {
                            <p class="text-sm font-semibold text-deemphasized">
                                Sold out
                            </p>
                        }
                    }
                </div>
            </div>

            <div class="flex items-center text-sm">
                <span class="mr-1 text-deemphasized/70">from</span
                ><span class="font-semibold">{{
                    departure.price | currency: 'USD' : 'code' : '1.0-0'
                }}</span>
                <div class="mx-2 h-4 w-[1px] bg-lightgrey"></div>
                <span class="mr-1 text-deemphasized/70">Deposit</span
                ><span class="font-semibold">{{
                    departure.deposit | currency: 'USD' : 'code' : '1.0-0'
                }}</span>
            </div>
        </div>
        @if (open) {
            <div
                class="mt-4 items-center border-t border-grey-150 pt-4 md:hidden md:justify-between">
                <div class="flex">
                    <fa-icon class="text-lg" [icon]="faArrowRight"></fa-icon>
                    <p class="ml-2 text-xl font-semibold">
                        {{ departure.end_date | date: 'mediumDate' }}
                    </p>
                </div>
                <p class="mt-2 text-xs text-grey-500">
                    {{ departure.additional_text }}*
                </p>
                <div
                    class="mt-3 flex w-fit items-center gap-4 rounded-2xl bg-grey-100 p-4 py-3">
                    <img class="mr-2" src="/assets/images/trips/bed-icon.svg" />
                    <div class="flex flex-col">
                        <p class="text-xl font-semibold">
                            +${{ departure.single_supplement }}
                        </p>
                        <p class="text-sm text-grey-500">own room</p>
                    </div>
                    <div class="relative">
                        <img
                            (click)="toggleOpenTooltip()"
                            src="/assets/images/trips/info-icon.svg"
                            class="h-8 w-8" />
                        @if (openTooltip) {
                            <div
                                class="absolute left-2/4 h-[10px] w-[10px] rotate-45 rounded-tl-sm bg-white"></div>
                        }
                        @if (openTooltip) {
                            <div
                                class="absolute -right-32 top-9 w-72 rounded-xl bg-white text-sm text-grey-500 shadow-md">
                                <div
                                    class="cursor-pointer pr-2 pt-2 text-right">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 492 492"
                                        class="inline h-7 w-7 fill-current p-2"
                                        (click)="toggleOpenTooltip()">
                                        <path
                                            d="M300 246L484 62a27 27 0 000-38L468 8a27 27 0 00-38 0L246 192 62 8a27 27 0 00-38 0L8 24a27 27 0 000 38l184 184L8 430a27 27 0 000 38l16 16a27 27 0 0038 0l184-184 184 184a27 27 0 0038 0l16-16a27 27 0 000-38L300 246z" />
                                    </svg>
                                </div>
                                <p class="-mt-4 p-4 pt-0">
                                    Upgrade to your own room by paying a charge
                                    of ${{ departure.single_supplement }}.
                                    Otherwise you will share a room with another
                                    traveller!
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        <div class="flex md:ml-4">
            @if (!isSoldOut) {
                <app-cta-button
                    type="button"
                    [additionalClasses]="['mt-4 px-8 md:mt-0']"
                    (onClick)="join(departure)"
                    data-testid="enquireButtonOnSelfBookingDepartureDetail">
                    Enquire
                </app-cta-button>
            }

            @if (
                selfBookingFeatureFlagSignal() &&
                departure.self_booking_enabled &&
                !isSoldOut
            ) {
                <app-cta-button
                    type="link"
                    [link]="['/checkout/' + departure.id]"
                    [additionalClasses]="['mt-4 px-8 md:mt-0 ml-2']"
                    [disabled]="isSoldOut"
                    variant="secondary">
                    Book
                </app-cta-button>
            }

            <div
                (click)="toggleOpen()"
                class="hidden cursor-pointer items-center p-4 md:flex">
                <svg
                    class="inline h-3 flex-shrink-0 transform fill-current text-grey-500 transition duration-500"
                    [ngClass]="{ '-scale-y-100': open }"
                    viewBox="0 0 20 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0.666666 2.33333C0.666056 2.02179 0.774557 1.71988 0.973331 1.48C1.08526 1.34498 1.22273 1.23338 1.37786 1.15158C1.53299 1.06978 1.70273 1.01938 1.87737 1.00328C2.052 0.987179 2.2281 1.00569 2.39557 1.05775C2.56304 1.10981 2.7186 1.19439 2.85333 1.30666L10 7.28L17.16 1.52C17.2964 1.40924 17.4533 1.32653 17.6218 1.27662C17.7902 1.22672 17.9669 1.21059 18.1416 1.22918C18.3163 1.24776 18.4856 1.30069 18.6398 1.38492C18.794 1.46915 18.93 1.58303 19.04 1.72C19.1614 1.85795 19.2529 2.01951 19.3089 2.19452C19.3649 2.36954 19.3841 2.55424 19.3653 2.73703C19.3466 2.91982 19.2902 3.09676 19.1998 3.25673C19.1094 3.41671 18.9869 3.55627 18.84 3.66666L10.84 10.1067C10.6014 10.3028 10.3022 10.41 9.99333 10.41C9.6845 10.41 9.38524 10.3028 9.14666 10.1067L1.14667 3.44C0.985309 3.30624 0.857757 3.13633 0.774359 2.94405C0.69096 2.75177 0.654064 2.54254 0.666666 2.33333Z" />
                </svg>
            </div>
        </div>
    </div>

    @if (open) {
        <div
            class="mt-4 hidden border-t border-grey-150 pt-4 md:flex md:justify-between">
            <div class="flex">
                <fa-icon class="text-lg" [icon]="faArrowRight"></fa-icon>
                <p class="ml-2 text-xl font-semibold">
                    {{ departure.end_date | date: 'mediumDate' }}
                </p>
            </div>
            @if (departure.additional_text) {
                <p class="ml-4 text-sm text-grey-500">
                    {{ departure.additional_text }}*
                </p>
            }
            <div
                class="flex w-fit items-center gap-4 rounded-2xl bg-grey-100 p-4 py-3">
                <img class="mr-2" src="/assets/images/trips/bed-icon.svg" />
                <div class="flex flex-col">
                    <p class="text-xl font-semibold">
                        +${{ departure.single_supplement }}
                    </p>
                    <p class="text-sm text-grey-500">own room</p>
                </div>
                <div class="relative">
                    <img
                        (mouseenter)="toggleOpenTooltip()"
                        (mouseleave)="toggleOpenTooltip()"
                        src="/assets/images/trips/info-icon.svg"
                        class="h-8 w-8" />
                    @if (openTooltip) {
                        <div
                            class="absolute left-2/4 h-[10px] w-[10px] rotate-45 rounded-tl-sm bg-white"></div>
                    }
                    @if (openTooltip) {
                        <div
                            class="absolute -right-8 top-9 z-20 w-72 rounded-xl bg-white p-4 text-sm text-grey-500 shadow-md">
                            Upgrade to your own room by paying a charge of ${{
                                departure.single_supplement
                            }}. Otherwise you will share a room with another
                            traveller!
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</div>
